
        <span #marquee>
            {{ newsString }}
        </span>
    